import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <nav className="flex items-center justify-between px-6 py-4 bg-white shadow-md sticky top-0 z-50">
      {/* Logo */}
      <Link to="/" className="text-2xl font-bold text-purple-700">
        Smarty
      </Link>

      {/* Search Box */}
      <div className="hidden md:flex items-center space-x-4 w-1/2">
        <input
          type="text"
          placeholder="Search for anything"
          className="w-full border border-gray-300 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-purple-600"
        />
      </div>

      {/* Right Side Buttons */}
      <div className="flex items-center space-x-4 text-gray-700 font-medium">
        
  

     

        <button>Teach</button>
        <button>Login</button>

        <button className="border border-purple-700 text-purple-700 px-4 py-1 rounded hover:bg-purple-700 hover:text-white transition">
          Sign up
        </button>
      </div>
    </nav>
  );
}
